import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionSetupPage } from "@/pages/subscription-setup";

type SearchParams = {
  plan?: string;
};

const RouteComponent = () => {
  const { plan } = Route.useSearch();
  return <SubscriptionSetupPage plan={plan} />;
};

export const Route = createFileRoute(
  "/_authed/_noSidebar/$companySlug/subscribe/",
)({
  validateSearch: (search: Record<string, unknown>): SearchParams => ({
    plan: typeof search.plan === "string" ? search.plan : undefined,
  }),
  component: RouteComponent,
});
